import React from "react";
import { REVIEW_TYPE_LABELS } from "../copy/reviewStatusCopy";
import { formatWhen, verdictLabel } from "./reviewDisplay";

function resultLabel(item) {
  if (item.activity === "running") return "Running";
  if (item.activity === "failed") return "Failed";
  if (item.currency === "stale") return "Earlier commit";
  if (item.verdict === "aligned") return "Aligned";
  if (item.verdict === "insufficient_context") return "Insufficient context";
  if (item.verdict === "discuss_first" || item.verdict === "changes_recommended") return "Findings";
  return verdictLabel(item.verdict);
}

function ReviewSummary({ item, showType }) {
  const findings = item.findingCount ?? item.criteriaCount ?? 0;
  return (
    <>
      <span className="rr-inbox-pr">
        <strong>
          {item.owner && item.name ? `${item.owner}/${item.name}` : item.title || "Review"}
          {item.pullNumber ? ` #${item.pullNumber}` : ""}
        </strong>
        <span className="rr-muted">
          {item.owner && item.name ? item.title || "Untitled review" : ""}
          {showType ? `${item.owner && item.name ? " · " : ""}${REVIEW_TYPE_LABELS[item.type]}` : ""}
          <span className="rr-inbox-compact"> · {findings} · {formatWhen(item.completedAt || item.updatedAt) || "—"}</span>
        </span>
      </span>
      <span className="rr-inbox-result">{resultLabel(item)}</span>
      <span className="rr-count">{findings}</span>
      <span className="rr-when">{formatWhen(item.completedAt || item.updatedAt) || "—"}</span>
    </>
  );
}

export default function ReviewListItem({
  item,
  onOpen,
  showType = false,
  selectable = false,
  selected = false,
  onToggleSelect,
  onDelete,
  deleting = false,
}) {
  const canDelete = Boolean(onDelete) && (item.type === "decision" || item.type === "acceptance");
  const reviewLabel =
    item.owner && item.name
      ? `${item.owner}/${item.name}${item.pullNumber ? ` #${item.pullNumber}` : ""}`
      : item.title || item.id;

  if (!selectable) {
    return (
      <button type="button" className="rr-inbox-row" onClick={() => onOpen(item)}>
        <ReviewSummary item={item} showType={showType} />
      </button>
    );
  }

  return (
    <div className={`rr-inbox-row${selected ? " is-selected" : ""}`}>
      <label className="rr-inbox-select" onClick={(event) => event.stopPropagation()}>
        <input
          type="checkbox"
          checked={selected}
          disabled={!canDelete}
          aria-label={`Select ${reviewLabel}`}
          onChange={() => onToggleSelect?.(item)}
        />
      </label>
      <button type="button" className="rr-inbox-open" onClick={() => onOpen(item)}>
        <ReviewSummary item={item} showType={showType} />
      </button>
      {canDelete ? (
        <button
          type="button"
          className="rr-inbox-delete"
          disabled={deleting}
          aria-label={`Remove review ${reviewLabel} from list`}
          onClick={(event) => {
            event.stopPropagation();
            onDelete(item);
          }}
        >
          Remove
        </button>
      ) : (
        <span className="rr-inbox-delete-spacer" aria-hidden="true" />
      )}
    </div>
  );
}
